import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=7dde179c"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dde179c')) {
      api.createRecord('7dde179c', component.options)
    } else {
      api.reload('7dde179c', component.options)
    }
    module.hot.accept("./Dialog.vue?vue&type=template&id=7dde179c", function () {
      api.rerender('7dde179c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/base/Dialog.vue"
export default component.exports